import { render } from "./ParentView.vue?vue&type=template&id=5cfd0b94"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__